import { render, staticRenderFns } from "./BodyEditor.vue?vue&type=template&id=83aacb86&scoped=true"
import script from "./BodyEditor.vue?vue&type=script&lang=ts"
export * from "./BodyEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83aacb86",
  null
  
)

export default component.exports